import React from 'react';

const Home = ({ lang }) => {
  const content = {
    fr: {
      welcome: "Bienvenue",
      title: "L'Islam cette lumière pour tous",
      author: "Abou Soumaya Al-ABDOULI",
      authorTitle: "Docteur Es sciences physiques et universitaire",
      authorBio: "Marié et père de cinq enfants. Il a longtemps étudié les sciences islamiques.",
      objectiveTitle: "Objectif du Site",
      objective: "L'objectif premier de ce site internet est de faire connaître l'Islam, la Religion parachevée d'Allah, selon la Parole d'Allah (le Coran) et les Enseignements Prophétiques (la Sounnah), par le partage des connaissances et l'échange des avis sur le sujet.",
      objective2: "Ce Site est ouvert à tout le monde et les documents qu'il contient sont à disposition gratuite à la seule double condition de les utiliser tels qu'ils sont, c'est-à-dire sans la moindre altération, et à but non lucratif."
    },
    en: {
      welcome: "Welcome",
      title: "Islam: A Light for All",
      author: "Abu Soumaya Al-ABDOULI",
      authorTitle: "Doctorate in physical sciences and university professor",
      authorBio: "Married and the father of five children. He has extensively studied Islamic sciences.",
      objectiveTitle: "Website Objective",
      objective: "The primary objective of this website is to promote Islam, the perfected religion of Allah, according to the Word of Allah (the Quran) and the Prophetic teachings (the Sunnah), through the sharing of knowledge and the exchange of opinions on the subject.",
      objective2: "This Site is open to everyone, and the documents it contains are available free of charge, provided they are used exactly as they are, without any alteration, and for non-commercial purposes."
    }
  };

  const c = content[lang];

  return (
    <div className="home">
      <section className="hero">
        <h1>{c.welcome}</h1>
        <h2>{c.title}</h2>
      </section>
      
      <section className="about">
        <div className="author-card">
          <div className="author-icon">👤</div>
          <h3>{c.author}</h3>
          <p className="author-title">{c.authorTitle}</p>
          <p>{c.authorBio}</p>
        </div>
        
        <div className="objective-card">
          <div className="objective-icon">🎯</div>
          <h3>{c.objectiveTitle}</h3>
          <p>{c.objective}</p>
          <p className="mt">{c.objective2}</p>
        </div>
      </section>
    </div>
  );
};

export default Home;
